export default function SectionCard({ title, icon: Icon, children, actions, className }) {
    return (
      <section className={`section-card ${className}`}>
        <div className="section-header mb-2 d-flex justify-between align-center">
          <div className="d-flex gap-2 align-center">
            {Icon && <Icon size={16} />}
          <h4 className="m-0">{title}</h4>
          </div>
          {actions}
        </div>
  
        <div className="section-body">{children}</div>
      </section>
    );
  }